/**
 * 浏览器这一侧怎么对待「预渲染的那份 HTML」（2026-11-04，为什么要预渲染见 src/prerender/seo.ts）。
 *
 * 公开页面的 HTML 里，`<div id="root">` 前面多了一个 `<div id="prerender" data-path="/docs/rule-breaker">`，
 * 里面是构建时用同一套组件渲染出来的正文。它在这里有三条规矩：
 *
 *   1. **真页面画好之前一直留着**：React 起来、问完「登录了没有」、懒加载的页面代码下完，
 *      这几步加起来可能一秒多。这段时间里用户看的就是它（以前是一个转圈）。
 *   2. **真页面画好的那一刻拿掉**（公开页面共用的 LandingShell 挂上时）。两份内容一样，看不出切换。
 *   3. **当前地址不是它渲染的那一页就立刻拿掉**：登录了的人打开首页会被送去总览、
 *      启动出错、会话过期 —— 这些时候留着它就是一页错的内容。
 *
 * 已登录的人打开首页时连闪一下首页都不该有：上一次启动时记下「登录过」（localStorage 一个标记），
 * index.html 里那段内联脚本看到标记就给 <html> 加 `pre-hide`，首页那份预渲染直接不显示。
 * 爬虫没有 localStorage，照样看得到；没登录的人也照样看得到。
 */

export const PRERENDER_ID = 'prerender';
/** 和 index.html 里那段内联脚本读的是同一个键 */
export const SIGNED_IN_KEY = 'jyfk.signedIn';

function el(): HTMLElement | null {
  return typeof document === 'undefined' ? null : document.getElementById(PRERENDER_ID);
}

/** 现在屏幕上是不是正显示着预渲染的内容（在的话，转圈就不用画了） */
export function showingPrerender(): boolean {
  const e = el();
  return e !== null && !document.documentElement.classList.contains('pre-hide');
}

/** 拿掉预渲染的内容。可以反复调 */
export function dropPrerender(): void {
  el()?.remove();
  if (typeof document !== 'undefined') document.documentElement.classList.remove('pre-hide');
}

/** 预渲染的是哪一页。没有 = null */
export function prerenderedPath(): string | null {
  return el()?.dataset['path'] ?? null;
}

/** 记下这台电脑上「登录着」还是「游客」。存不下（隐身模式）就算了，只是首页会多闪一下 */
export function rememberSignedIn(signedIn: boolean): void {
  try {
    if (signedIn) localStorage.setItem(SIGNED_IN_KEY, '1');
    else localStorage.removeItem(SIGNED_IN_KEY);
  } catch {
    /* 忽略 */
  }
}
